import { render, staticRenderFns } from "./your-ecological-footprint.vue?vue&type=template&id=3e4c1148&"
import script from "./your-ecological-footprint.vue?vue&type=script&lang=js&"
export * from "./your-ecological-footprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports